import theme from '@/config/theme';
import styled from 'vue-styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 1rem;
  border-radius: 0.9rem;
  box-shadow: ${theme.shadow.small};
  background-color: ${theme.colors.white};

  > div {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;

    :hover {
      cursor: pointer;
    }

    .contentText {
      padding: 0 1rem;
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;

      .title {
        font-size: 0.9rem;
        color: ${theme.colors.gray6};
        font-weight: 400;
        font-style: normal;
        user-select: none;
        display: block;
        max-width: 85%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      > svg {
        color: ${theme.colors.gray4};
      }

      &.clicked {
        background-color: ${theme.colors.primaryBlue};
        border-radius: 0.9rem;

        .title,
        svg {
          color: ${theme.colors.white};
        }

        svg {
          transform: rotate(180deg);
        }
      }
    }

    .accordionContent {
      user-select: none;
      width: 100%;
      box-shadow: ${theme.shadow.btDefault};
      border-radius: 0.9rem;

      > * {
        padding: 1rem;
      }
    }

    .accordion-enter-active,
    .accordion-leave-active {
      will-change: height, opacity;
      transition: height 0.4s ease, opacity 0.4s ease;
      overflow: hidden;
    }

    .accordion-enter,
    .accordion-leave-to {
      height: 0 !important;
      opacity: 0;
    }
  }
`;
